var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDisconnectSupportTechnician = function SvgIconDisconnectSupportTechnician(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FD7F38",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "m9.75 5.524.967-.967a6.17 6.17 0 1 1 8.726 8.726l-.969.969M5.53 9.745l-.972.972a6.17 6.17 0 1 0 8.726 8.726l.965-.965"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FD7F38",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M3.8 6.363 1.75 5.85M6.363 3.8 5.85 1.75M20.2 17.638l2.05.512m-4.613 2.05.513 2.05"
  })));
};
export { SvgIconDisconnectSupportTechnician as ReactComponent };
export default __webpack_public_path__ + "9d4ccb0af4eaf0ea7392832dc88b9f79.svg";